import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import GenericPicker from "../../../../../components/utilities/GenericPicker";
import { getEnvironmentVariable } from "../../../../../global/environmentVariables";

const SINGLE_GAME_SYSTEM = getEnvironmentVariable("SINGLE_GAME_SYSTEM");

export default function EventCreationGameStore({
  gameStore,
  authContext,
  setEventSubType,
  setGameStore,
  gameStoreDict,
  setStep,
  gameStores
}) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.eventCreation"
  });

  return (
    <Grid item xs={12}>
      <GenericPicker
        name="gameStore"
        label={t("organization")}
        value={gameStore || ""}
        handleChange={(e) => {
          if (e.target.value === "self") {
            setGameStore({
              name: "Self (No Organization)"
            });
          } else {
            setGameStore({
              id: e.target.value,
              ...gameStoreDict[e.target.value]
            });
          }

          setStep(SINGLE_GAME_SYSTEM ? 2 : 1);
        }}
        list={gameStores || []}
        inclAny={false}
      />
    </Grid>
  );
}
